import React from 'react';
import ScrollToTop from 'react-scroll-up';

const UpArrow = () => (
  <ScrollToTop showUnder={280}>
    <i className="material-icons">&#xE316;</i>
  </ScrollToTop>
)

export default UpArrow;



// WEBPACK FOOTER //
// ./src/container/UpArrow/UpArrow.js